import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { Col, Layout as AntdLayout, Row } from "antd";
import { useStores } from "../../store";
import { LandingPage } from "../../pages/landingPage";
import { GetApiKey } from "../../pages/getApiKey";
import { Page } from "../../models";
import { LeftOutlined } from "@ant-design/icons";
import "./index.scss";
import { ApiKeyDetail } from "../../pages/apiKeyDetail";
import { Spinner } from "../Spinner";
import { useGet } from "../../hooks/useGet";
import { Help } from "../../pages/help";
import { NftsOverviewLazy } from "../../pages/nftsOverviewLazy";
import { NftsOverviewMinted } from "../../pages/nftsOverviewMinted";
export var Layout = observer(function () {
  var Header = AntdLayout.Header,
      AntdContent = AntdLayout.Content;

  var _usePageContent = usePageContent(),
      page = _usePageContent.page,
      header = _usePageContent.header;

  var _useGet = useGet("/api-key"),
      data = _useGet.data;

  var _useStores = useStores(),
      pageStore = _useStores.pageStore,
      apiKeyStore = _useStores.apiKeyStore;

  useEffect(function () {
    if (data) {
      if (data.apiKey) {
        apiKeyStore.setApiKey(data);
        pageStore.setPage(Page.API_KEY_DETAIL);
      } else {
        pageStore.setPage(Page.LANDING);
      }
    }
  }, [data]);
  return /*#__PURE__*/React.createElement(AntdLayout, {
    className: "tatum"
  }, /*#__PURE__*/React.createElement(Header, {
    style: {
      backgroundColor: "#fff"
    }
  }, /*#__PURE__*/React.createElement(Row, {
    justify: "space-around",
    align: "middle"
  }, /*#__PURE__*/React.createElement(Col, {
    span: 8
  }, header), /*#__PURE__*/React.createElement(Col, {
    span: 8,
    offset: 8,
    style: {
      display: "flex",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React.createElement("div", null, "A plugin by", " ", /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    rel: "noreferrer",
    href: "https://t.me/LukasKotol"
  }, "Lukas Kotol"))))), /*#__PURE__*/React.createElement(AntdContent, {
    style: {
      backgroundColor: "#f9f9f9"
    }
  }, /*#__PURE__*/React.createElement(Row, {
    style: {
      backgroundColor: "#f9f9f9"
    }
  }, /*#__PURE__*/React.createElement(Col, {
    span: 12,
    offset: 6,
    style: {
      display: "flex",
      justifyContent: "center",
      flexDirection: "column"
    }
  }, !data ? /*#__PURE__*/React.createElement("div", {
    style: {
      height: "100vh",
      marginTop: "100px"
    }
  }, /*#__PURE__*/React.createElement(Spinner, null)) : page))));
});

var usePageContent = function usePageContent() {
  var _useStores2 = useStores(),
      pageStore = _useStores2.pageStore;

  var defaultPage = {
    page: /*#__PURE__*/React.createElement(LandingPage, null),
    header: "NFT Maker"
  };

  switch (pageStore.page) {
    case Page.API_KEY_DETAIL:
      return {
        page: /*#__PURE__*/React.createElement(ApiKeyDetail, null),
        header: "NFT Maker"
      };

    case Page.LANDING:
      return defaultPage;

    case Page.HELP:
      return {
        page: /*#__PURE__*/React.createElement(Help, null),
        header: /*#__PURE__*/React.createElement(BackToMainPage, {
          title: "Need Help?"
        })
      };

    case Page.GET_API_KEY:
      return {
        page: /*#__PURE__*/React.createElement(GetApiKey, null),
        header: /*#__PURE__*/React.createElement(BackToMainPage, {
          title: "Get your Tatum API key"
        })
      };

    case Page.NFTS_MINTED:
      return {
        page: /*#__PURE__*/React.createElement(NftsOverviewMinted, null),
        header: /*#__PURE__*/React.createElement(BackToMainPage, {
          title: "NFTs Sold"
        })
      };

    case Page.NFTS_LAZY:
      return {
        page: /*#__PURE__*/React.createElement(NftsOverviewLazy, null),
        header: /*#__PURE__*/React.createElement(BackToMainPage, {
          title: "NFTs created"
        })
      };

    default:
      return defaultPage;
  }
};

var BackToMainPage = function BackToMainPage(_ref) {
  var title = _ref.title;

  var _useStores3 = useStores(),
      pageStore = _useStores3.pageStore,
      apiKeyStore = _useStores3.apiKeyStore;

  var nextPage = function nextPage() {
    if (apiKeyStore.apiKey) {
      pageStore.setPage(Page.API_KEY_DETAIL);
    } else {
      pageStore.setPage(Page.LANDING);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "back-to-landing-page-container",
    onClick: nextPage
  }, /*#__PURE__*/React.createElement(LeftOutlined, null), /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, title));
};